// RB-MY01-PalmGarden.web/src/components/ImageUploadTest.tsx
import React, { useState, useEffect } from 'react';

const ImageUploadTest = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [debugInfo, setDebugInfo] = useState<any>(null);

  useEffect(() => {
    // Fetch debug info when component mounts
    fetch('http://localhost:8080/api/debug')
      .then(res => res.json())
      .then(data => setDebugInfo(data))
      .catch(err => console.error('Error fetching debug info:', err));
  }, []);

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    
    setError(null);
    setUploading(true);
    
    // Create a FormData object to send the files
    const formData = new FormData();
    Array.from(e.target.files).forEach(file => {
      formData.append('images', file);
    });
    
    try {
      const response = await fetch('http://localhost:8080/api/upload', {
        method: 'POST',
        body: formData,
      });
      
      const data = await response.json();
      console.log('Upload response:', data);
      
      if (!response.ok) {
        throw new Error(data.message || 'Failed to upload images');
      }
      
      setUploadedImages(prev => [...prev, ...data.urls]);
      
      // Refresh debug info
      fetch('http://localhost:8080/api/debug')
        .then(res => res.json())
        .then(data => setDebugInfo(data))
        .catch(err => console.error('Error fetching debug info:', err));
    } catch (error) {
      console.error('Error uploading images:', error);
      setError(error instanceof Error ? error.message : 'Failed to upload images');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Image Upload Test</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          disabled={uploading}
        />
        {uploading && <p>Uploading...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Uploaded Images ({uploadedImages.length})</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px' }}>
          {uploadedImages.map((url, index) => (
            <div key={index} style={{ border: '1px solid #ddd', borderRadius: '4px', overflow: 'hidden' }}>
              <img src={url} alt={`Uploaded ${index}`} style={{ width: '100%', height: '150px', objectFit: 'cover' }} />
              <div style={{ padding: '5px', fontSize: '12px', wordBreak: 'break-all' }}>{url}</div>
            </div>
          ))}
        </div>
      </div>
      
      {debugInfo && (
        <div style={{ marginTop: '30px' }}>
          <h3>Server Debug Info</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default ImageUploadTest; 